// BEAUTY PROFILE · 뷰티 속성 — 퍼스널 컬러 · 피부 타입 · 피부 고민 · 선호/비선호 성분.
//
// SF 실데이터(CreatorsView/CreatorDto 서빙). 브랜드가 성분·피부고민으로 캐스팅하는 핵심 자산.
// 값 없는 항목은 "—". 5필드 전부 비면 섹션 자체 생략(graceful degrade).
import type { ProfileData } from '../../creatorsApi'
import { SectionHeader } from './SectionHeader'
import { orDash } from './format'

const FIELDS: { key: keyof ProfileData['beautyAttributes']; label: string }[] = [
  { key: 'personalColor', label: '퍼스널 컬러' },
  { key: 'skinType', label: '피부 타입' },
  { key: 'skinWorry', label: '피부 고민' },
  { key: 'preferenceIngredient', label: '선호 성분' },
  { key: 'dislikeIngredient', label: '비선호 성분' },
]

export function BeautyProfile({ attributes }: { attributes: ProfileData['beautyAttributes'] }) {
  const hasAny = FIELDS.some((f) => attributes[f.key]?.trim())
  if (!hasAny) return null

  return (
    <section className="mt-[34px]">
      <SectionHeader label="BEAUTY PROFILE · 뷰티 속성" />
      {/* 카드 흰색(bg-paper) + hairline 구분선은 셀 border(r/b) + 컨테이너 border(l/t)로 유지 */}
      <div className="flex flex-wrap border-l border-t border-line-hairline bg-paper">
        {FIELDS.map((f) => (
          <div key={f.key} className="min-w-[200px] flex-1 border-b border-r border-line-hairline p-4">
            <div className="font-text text-[11px] text-fg-3">{f.label}</div>
            <div className="mt-[5px] break-keep font-text text-[14px] font-medium leading-[1.4] text-fg-1">
              {orDash(attributes[f.key])}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
